import { IPlan, IUserSettings } from '@lifetools/shared-app-data';
import { services } from '@lifetools/shared-services';
import { ITimestamp, toTimestamp } from '@lifetools/shared-utils-time';

export const getDefaultPlan = (userSettings: IUserSettings): IPlan => ({
  type: 'trial',
  createdAt: userSettings.createdAt as ITimestamp ||
             toTimestamp(services.auth.api.currentUser().metadata.creationTime),
});
